$( document ).ready(function() {
    a = $(".header-header").outerHeight();
     $(".header-btn").css({"top":a+"px"});
    $(".custom_home_banner_sec").css({"padding-top":a+"px"});
  
     $(".header-menu").click(function(){
        $(".header-close").show();
        $(this).hide();
       $(".header-btn").addClass("active-heade-btn");
       
    });

  $(".header-close").click(function(){
        $(".header-menu").show();
        $(this).hide();
        $(".header-btn").removeClass("active-heade-btn");
    });
 
})